/* Framewick: resume a saved frame.
 *
 * Opt in by query string only. With no ?fw_resume= in the URL this file
 * returns immediately and the page behaves exactly as it does today.
 *
 * It reuses the same trick as the /pages/start handoff in
 * snippets/fw-photo-handoff.liquid: the photograph already lives at a
 * permanent upload URL, so nothing is uploaded again. We replay it into
 * the builder, write the line item properties Upload Lift would normally
 * write, and then put the size, mount and colour back.
 *
 * Links are stamped with a date and expire after 30 days, which is what
 * the email promises. If the file has been purged sooner than that we say
 * so plainly rather than rendering an empty frame.
 */
(function () {
  'use strict';

  var MAX_DAYS = 30;

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var raw = params.get('fw_resume');
  if (!raw) return;

  var cover = window.__fwCover || { label: function () {}, hide: function () {} };
  var done = false;

  function uncover() { if (done) return; done = true; cover.hide(); }

  function clean() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('fw_resume');
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  }

  function say(text) {
    clean(); uncover();
    var host = document.querySelector('[data-frame-ref="uploadField"]');
    host = (host && host.closest('.fw-step')) || document.querySelector('[data-fw-pdp]');
    if (!host) return;
    var p = document.createElement('p');
    p.className = 'fw-resume__note';
    p.setAttribute('data-fw-resume-note', '');
    p.style.cssText = 'margin:0 0 16px;font-size:15px;line-height:1.5;color:#5C6762';
    p.textContent = text;
    host.insertBefore(p, host.firstChild);
  }

  function decode(s) {
    var b = s.replace(/-/g, '+').replace(/_/g, '/');
    while (b.length % 4) b += '=';
    return JSON.parse(decodeURIComponent(escape(window.atob(b))));
  }

  var d = null;
  try { d = decode(raw); } catch (e) { clean(); return; }
  if (!d || !d.u || !d.w || !d.h) { clean(); return; }

  if (d.t && (Date.now() - d.t) > MAX_DAYS * 864e5) {
    say('That link has expired. Saved frames are kept for 30 days. Pop your photo in again and we will set it straight back up.');
    return;
  }

  cover.label('Bringing your frame back', null);

  /* the line item properties Upload Lift would normally write */
  function setField(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  /* put the size, mount and colour back once the options exist */
  function restoreOptions() {
    if (!d.o || !d.o.length) return;
    var tries = 0;
    (function go() {
      tries++;
      var any = false;
      d.o.forEach(function (val, i) {
        if (!val) return;
        var sel = 'input[data-index="option' + (i + 1) + '"]';
        var r = Array.prototype.slice.call(document.querySelectorAll(sel))
          .filter(function (x) { return x.value === val; })[0];
        if (!r || r.disabled || r.checked) return;
        any = true;
        var lbl = r.id ? document.querySelector('label[for="' + r.id + '"]') : null;
        if (lbl) { lbl.click(); } else { r.click(); }
      });
      if (any && tries < 25) { setTimeout(go, 160); return; }
      uncover();
    })();
  }

  function replay() {
    var pdp = document.querySelector('[data-fw-pdp]');
    var up = document.querySelector('[data-frame-ref="uploadField"]');
    var fp = document.querySelector('frame-product');
    if (!pdp || !up || !fp || (fp.matches && !fp.matches(':defined'))) return false;

    var detail = { url: d.u, uuid: d.id || '', meta: { width: d.w, height: d.h } };

    /* draws the photo in the frame and works out which sizes are sharp enough */
    try { up.dispatchEvent(new CustomEvent('upload:added', { detail: detail, bubbles: true })); }
    catch (e) { return false; }

    /* the page has worked the photo out once it has sized every option */
    if (!document.querySelector('input[data-index=option1][data-frame-calculated-dpi]')) return false;

    pdp.setAttribute('data-fw-img-w', String(d.w));
    pdp.setAttribute('data-fw-img-h', String(d.h));

    var vi = document.querySelector('input[name=id],select[name=id]');
    var form = vi && vi.form;
    if (form) {
      setField(form, 'properties[_user_image]', String(d.u).replace(/^\/\//, 'https://'));
      if (d.id) setField(form, '_cl-upload[]', d.id);
    }

    /* tells the page the upload is done, which opens the size step */
    try { up.dispatchEvent(new CustomEvent('FilePond:processfile', { detail: {} })); } catch (e) {}
    return true;
  }

  function start() {
    var tries = 0;
    (function attempt() {
      tries++;
      if (replay()) { clean(); restoreOptions(); return; }
      if (tries > 150) { clean(); uncover(); return; }
      setTimeout(attempt, 100);
    })();
  }

  /* the photograph has to still be there. Upload Lift may have purged it
     before our own 30 days are up, and a frame with nothing in it is a
     worse experience than being told plainly. */
  var probe = new Image();
  probe.onload = start;
  probe.onerror = function () {
    say('We could not find that photo any more. Pop it in again and we will set your frame straight back up.');
  };
  probe.src = d.u;

  setTimeout(uncover, 45000);
})();
